require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./el-millonario-negocio-que-es-la-uefa-champions-league.json") })
        }
      }, "path---el-millonario-negocio-que-es-la-uefa-champions-league");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---el-millonario-negocio-que-es-la-uefa-champions-league!./.cache/json/el-millonario-negocio-que-es-la-uefa-champions-league.json
// module id = 447
// module chunks = 231608221292675